import { default as React } from "react";
import { Arrow } from "../shared/Navbar";

// import kanban_gz from "./kanban_gz.svgz";
export const Button = ({
    className,
    children,
    twWidth = "w-fit",
    noArrow,
    arrowDirection = "right",
    ...props
}: {
    noArrow?: boolean;
    arrowDirection?: "right" | "left";
    twWidth?: string;
} & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>) => {
    return (
        <button
            {...props}
            className={`
                font-medium group/arrow flex items-center justify-center rounded-full py-1.5 px-4 text-sm transition-all 
                outline-black outline-1 outline-offset-0
                ${className}
            `}
        >
            {arrowDirection === "left" && !noArrow && <Arrow flip />}
            {children}
            {arrowDirection === "right" && !noArrow && <Arrow />}
        </button>
    );
};
